import Store from '@/store'
import { notify } from '@/services/notifications'

export async function updateField(field, value) {
  const investor = Store.state.investorProfile.investor
  if (value === investor[field]) return
  try {
    await Store.dispatch('investorProfile/updateField', { field, value })
    notify({ type: 'success', title: `Saved ${field}` })
  } catch (error) {
    notify({ type: 'danger', title: 'Something went wrong' })
  }
}

export async function updateFields(data) {
  const investor = Store.state.investorProfile.investor
  try {
    await Store.dispatch('investorProfile/updateFields', data)
    notify({ type: 'success', title: 'Saved' })
  } catch (error) {
    notify({ type: 'danger', title: 'Something went wrong' })
  }
}
